import { Event } from '../../webshop-api/models';
import { LanguageCode } from '../translation';
import { LocaleCode } from '../translation/locale-code.enum';

export class DateTimeUtil {

    public static getFullDayNameFor(day: string, locale: LocaleCode, timezone: string): string {
        const formatter = new Intl.DateTimeFormat(locale, {
            timeZone: timezone,
            weekday: 'long',
        });

        const dayMap: any = {
            'sun' : 1385852400000, //'2013-12-01',
            'mon' : 1385938800000, //2013-12-02',
            'tue' : 1386025200000, //2013-12-03',
            'wed' : 1386111600000, //2013-12-04',
            'thu' : 1386198000000, //'2013-12-05',
            'fri' : 1386284400000, //'2013-12-06',
            'sat' : 1386370800000, //'2013-12-07',
        };

        return formatter.format(dayMap[day]);
    }

    public static isContinuous(event: Event): boolean {
        const startDate = new Date(event.startDateTime.dateTime).getTime();
        const endDate = event.endDateTime
            ? new Date(event.endDateTime.dateTime).getTime()
            : startDate;

        return startDate !== endDate;
    }

    public static getDateTimeLongFormatFor(locale: LanguageCode, timezone: string): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat(locale, {
            timeZone: timezone,
            weekday: 'long',
            year: 'numeric',
            day: 'numeric',
            month: 'long',
        });
    }

    public static getDateTimeFormatFor(locale: LanguageCode, timezone: string): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat(locale, {
            timeZone: timezone,
            weekday: 'short',
            year: 'numeric',
            day: 'numeric',
            month: 'short',
        });
    }

    public static getDayMonthFormatFor(locale: LanguageCode, timezone: string): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat(locale, {
            timeZone: timezone,
            day: '2-digit',
            month: '2-digit',
        });
    }

    public static getDayNameFormatFor(locale: LanguageCode, timezone: string): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat(locale, {
            timeZone: timezone,
            weekday: 'short',
        });
    }

    public static getDateTimeNumericFormatFor(locale: LanguageCode, timezone: string): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat(locale, {
            timeZone: timezone,
            year: 'numeric',
            day: 'numeric',
            month: 'numeric',
        });
    }

    public static getTimeFormatFor(locale: LanguageCode, timezone: string): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat(locale, {
            timeZone: timezone,
            hour: 'numeric',
            minute: 'numeric'
        });
    }

    public static getShortDayFormatFor(locale: LanguageCode): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat(locale, {
            day: '2-digit'
        });
    }

    public static getShortMonthFormatFor(locale: LanguageCode): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat(locale, {
            month: 'short'
        });
    }

    public static isLessThanDayAway(event: Event): boolean {
        const eventDate = new Date(event.startDateTime.dateTime);
        const dayByNumbers: number = 1000 * 60 * 60 * 24;
        const now: number = Date.now();

        return now <= eventDate.getTime()
            && now >= eventDate.getTime() - dayByNumbers;
    }

    public static getDaysDifference(date: string) {
        const targetDate = new Date(date);
        const currentDate = new Date();

        targetDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        const diffInMilliseconds = targetDate.getTime() - currentDate.getTime();
        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;

        return Math.ceil(diffInMilliseconds / oneDayInMilliseconds);
    }

}
